<template>
  <div v-if="additionalInfo.length" id="additionalImportant-info" class="preview__section">
    <h3 class="preview__title">
      {{ translations.textAInformation.text }}
    </h3>
    <template v-if="tourAdditional.more">
      <div v-for="additional in tourAdditional.start" :key="`additional-${additional.id}`" class="preview__include">
        <div class="preview__dot preview__dot--orange" />
        <span class="preview__include-text">{{ additional.content }}</span>
      </div>
      <span v-if="!showTourAdditional" class="preview__read-more" @click="showTourAdditional = true">{{ translations.textReadMore.text }}</span>
      <template v-if="showTourAdditional">
        <div v-for="additional in tourAdditional.more" :key="`additional-${additional.id}`" class="preview__include">
          <div class="preview__dot preview__dot--orange" />
           <span class="preview__include-text">{{ additional.content }}</span>
        </div>
        <span class="preview__read-more" @click="showTourAdditional = false">{{ translations.textHide.text }}</span>
      </template>
    </template>
    <template v-else>
      <div v-for="additional in tourAdditional" :key="`additional-${additional.id}`" class="preview__include">
        <div class="preview__dot preview__dot--orange" />
         <span class="preview__include-text">{{ additional.content }}</span>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  name: 'AdditionalInfo',
  props: {
    additionalInfo: { type: Array, default: () => [] },
    translations: { type: Object, default: () => ({}) }
  },
  data () {
    return {
      showTourAdditional: false
    }
  },
  computed: {
    tourAdditional () {
      return this.additionalInfo?.length > 4
        ? { start: this.additionalInfo.slice(0, 4), more: this.additionalInfo.slice(4) }
        : this.additionalInfo
    }
  }
}
</script>

<style lang="scss">
</style>
